import * as yup from 'yup';

export const ApiKeyFormSchema = yup.object().shape({
    name: yup
        .string()
        .required('Nome é obrigatório')
        .min(1, 'Nome deve ter pelo menos 1 caractere')
        .max(255, 'Nome deve ter no máximo 255 caracteres'),

    scopes: yup
        .array()
        .min(1, 'É obrigatório selecionar pelo menos um escopo')
        .required('É obrigatório selecionar pelo menos um escopo'),
});